module.exports = __webpack_public_path__ + "static/fonts/iconfont.85f898a1.ttf";